import { Reveal } from "@/components/Reveal";
import { IMPACT_METRICS } from "@/data/site";

const ACCENT = {
  orange: "text-orange",
  magenta: "text-magenta",
  indigo: "text-indigo-bright",
};
const SPANS = ["lg:col-span-5", "lg:col-span-4", "lg:col-span-3", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4"];

export function ImpactDashboard() {
  return (
    <section id="impact" className="relative overflow-hidden py-24 lg:py-32" data-testid="impact">
      <div className="ambient-orange pointer-events-none absolute right-0 top-1/4 h-[500px] w-[500px] opacity-60" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <div className="flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
            <div>
              <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-orange">The Impact</p>
              <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-none tracking-tight sm:text-5xl lg:text-6xl">
                Numbers that move the P&amp;L.
              </h2>
            </div>
            <p className="max-w-sm text-sm font-light leading-relaxed text-muted">
              Real results pulled straight from our case studies — measurable growth, sharper efficiency, stronger returns.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-12">
          {IMPACT_METRICS.map((m, i) => (
            <Reveal key={m.label} delay={i * 0.06} className={SPANS[i]}>
              <div className="tracing-card group h-full rounded-2xl border border-white/8 bg-surface p-8 transition-transform hover:-translate-y-1" data-testid={`metric-${i}`}>
                <div className={`font-display text-6xl font-black tracking-tighter lg:text-7xl ${ACCENT[m.accent]}`}>
                  {m.value}
                </div>
                <div className="mt-4 font-display text-lg font-semibold text-white">{m.label}</div>
                <div className="mt-1 text-sm text-muted">{m.sub}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
